// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore.js";
var name = "clipPlaneFragmentDeclaration";
var shader = "#ifdef CLIPPLANE\nvarying float fClipDistance;\n#endif\n#ifdef CLIPPLANE2\nvarying float fClipDistance2;\n#endif\n#ifdef CLIPPLANE3\nvarying float fClipDistance3;\n#endif\n#ifdef CLIPPLANE4\nvarying float fClipDistance4;\n#endif\n#ifdef CLIPPLANE5\nvarying float fClipDistance5;\n#endif\n#ifdef CLIPPLANE6\nvarying float fClipDistance6;\n#endif\n";
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export var clipPlaneFragmentDeclaration = { name: name, shader: shader };
//# sourceMappingURL=clipPlaneFragmentDeclaration.js.map